import CurrentPane from './currentPane';

export default CurrentPane;
